import getARMToCustomLevelMap from "./getARMToCustomLevelMap";
import { isNullOrUndefined } from "../../../../services/util";
export default function getARMToCustomLevel(armScore ,partner) {
  
  const mapping = getARMToCustomLevelMap(partner);
  
  if(!mapping) {
    return null;
  }

  if(isNullOrUndefined(armScore)) {
    return null;
  }

  // if the armScore is less than the first key, return the value of the first key - 1 in string
  if(armScore < parseFloat(mapping[0].key)) {
    return (parseInt(mapping[0].value) - 1).toString();
  }

  // if the armScore is greater than the last key, return null
  if(armScore > parseFloat(mapping[mapping.length - 1].key)) {
    return -1;
  }

  // if the armScore is equal to the last key, return the value of the last key
  if(armScore === parseFloat(mapping[mapping.length - 1].key)) {
    return mapping[mapping.length - 1].value;
  }
  
  // Convert the input to a string to match keys in the mapping
  const scoreStr = armScore.toString();

  // Iterate through the mapping to find the next key's value
  for (let i = 0; i < mapping.length - 1; i++) {
      if (mapping[i].key === scoreStr) {
          return mapping[i].value;
      }else if(parseFloat(mapping[i].key) < armScore && armScore < parseFloat(mapping[i+1].key)){
          return mapping[i+1].value;
      }
  }

  return null
}